module.exports = __webpack_public_path__ + "static/img/cont44_05.bc89403.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont44_05.jpg
// module id = lM2x
// module chunks = 0